import request from "@/utils/request";
import { store } from "@/vuex/store.js";

export function getUserInformations() {
    return request({
        url: "/api/services/app/Session/GetCurrentLoginInformations",
        method: "GET"
    });
}

export function updateUserPassword(data) {
    return request({
        url: "/api/services/app/Profile/ChangePassword",
        method: "POST",
        data
    });
}
export function userGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/User/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function login(data) {
    return request({
        url: "/api/TokenAuth/Authenticate",
        method: "post",
        headers: { "Abp.TenantId": process.env.VUE_APP_TENANT_ID },
        data
    });
}

export function getInfo(token) {
    return request({
        url: "/api/services/app/Session/GetCurrentLoginInformations",
        method: "get",
        params: { token }
    });
}

export function getUser(params) {
    return request({
        url: "/api/services/app/User/Get",
        method: "get",
        params
    });
}

export function updateWorkflowTourGuideToggle(data) {
    return request({
        url: "/api/services/app/User/UpdateWorkflowTourGuideToggle",
        method: "PUT",
        data
    });
}

export function logout() {
    store.dispatch("user/resetToken").then(() => {
        location.reload();
    });
}

export function userChangePassword(data) {
    return request({
        url: "/api/services/app/User/ChangePassword",
        method: "POST",
        data
    });
}

export function createUserV2(data) {
    return request({
        url: "/api/v2/services/app/User/CreateUser",
        method: "POST",
        data
    });
}

export function deleteUser(params) {
    return request({
        url: "/api/services/app/User/Delete",
        method: "DELETE",
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/user.js